import React from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import LoginPage from "./components/LoginPage";
import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/NavBar";
import ProfilePage from "./components/ProfilePage";
import SettingsPage from "./components/SettingsPage";
import Administration from "./components/AdministrationPage";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";
import FooterPage from "./components/FooterPage";
import NotProtectedRoute from "./components/NotProtectedRoute";
import HomePage from "./components/HomePage";
import WallPaper from "./components/WallPaper";
import { NavProvider, useNav } from "./context/NavContext";
import MaintenanceBanner from "./components/MaintenanceBanner";
import UpdatesPage from "./components/UpdatesPage";
import GeneralMessageBanner from "./components/GeneralMessageBanner";
import StockagePage from "./components/StockagePage";

const NameApp = `${process.env.REACT_APP_NAME || "Stockage"} ${process.env.REACT_APP_VER || ""}`.trim();

function AppShell({ children, withFooter = true }) {
  const { navMode } = useNav();
  const paddingClass = navMode === "hover" ? "lg:pl-4" : "lg:pl-72";

  return (
    <>
      <WallPaper />
      <Navbar />
      <div className={paddingClass}>
        <GeneralMessageBanner />
        <main className="px-4 sm:px-6 lg:px-8">{children}</main>
        {withFooter && <FooterPage />}
      </div>
    </>
  );
}

const routesMeta = {
  "/": {
    title: `${NameApp}`,
    description: `Accueil de ${NameApp}.`,
  },
  "/stockage": {
    title: `Stockage - ${NameApp}`,
    description: "Gestion des fichiers stockés.",
  },
  "/login": {
    title: `Connexion - ${NameApp}`,
    description: `Connectez-vous pour accéder à votre compte ${NameApp}.`,
  },
  "/profile": { title: `Profil - ${NameApp}`, description: "Votre profil utilisateur." },
  "/settings": { title: `Paramètres - ${NameApp}`, description: "Vos paramètres utilisateur." },
  "/administration": {
    title: `Administration - ${NameApp}`,
    description: `Gestion des utilisateurs et paramètres administratifs de ${NameApp}.`,
  },
  "/updates": {
    title: `Mises à jour - ${NameApp}`,
    description: `Historique des mises à jour de ${NameApp}.`,
  },
};

function MetaUpdater() {
  const location = useLocation();
  const meta = routesMeta[location.pathname] || routesMeta["/"];
  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
    </Helmet>
  );
}

export default function App() {
  return (
    <NavProvider>
      <Router>
        <MetaUpdater />
        <MaintenanceBanner />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<LoginPage />} />

          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <AppShell withFooter={false}>
                  <ProfilePage />
                </AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <AppShell withFooter={false}>
                  <SettingsPage />
                </AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/stockage"
            element={
              <ProtectedRoute>
                <AppShell>
                  <StockagePage />
                </AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/administration"
            element={
              <ProtectedAdminRoute>
                <AppShell withFooter={false}>
                  <Administration />
                </AppShell>
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/updates"
            element={
              <NotProtectedRoute>
                <AppShell>
                  <UpdatesPage />
                </AppShell>
              </NotProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <NotProtectedRoute>
                <AppShell>
                  <HomePage />
                </AppShell>
              </NotProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </NavProvider>
  );
}
